<!-- pricing-page.component.html -->
<div class="pc-page">

  <!-- ═══════════════════ HERO ═══════════════════ -->
  <section class="pc-hero">
    <div class="pc-container">
      <div class="pc-hero-panel">

        <div class="pc-hero-grid">

          <!-- ── copy + USP highlights ── -->
          <div class="pc-hero-copy">

            <h1 class="pc-hero-title">Expert 1:1 & Group Classes <br><span>£7.99/session*</span> </h1>

            <p class="pc-hero-lede">Four plans, one outcome: a clear, weekly picture of where your child
              stands and what it will take to get them into the school they're aiming for.</p>

            <!-- ── USP highlight grid (moved up — this is what needs to be seen without scrolling) ── -->
            <div class="pc-usp-grid">
              <div class="pc-usp-item">
                <span class="pc-usp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
                  </svg>
                </span>
                <span class="pc-usp-text">Expert-Led Live Lessons</span>
              </div>
              <div class="pc-usp-item">
                <span class="pc-usp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
                  </svg>
                </span>
                <span class="pc-usp-text">Personalised Progress Tracking</span>
              </div>
              <div class="pc-usp-item">
                <span class="pc-usp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                </span>
                <span class="pc-usp-text">Exam-Style Homework &amp; Tests</span>
              </div>
              <div class="pc-usp-item">
                <span class="pc-usp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </span>
                <span class="pc-usp-text">Regular Parent Updates &amp; PTMs</span>
              </div>
              <div class="pc-usp-item  ">
                <span class="pc-usp-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                </span>
                <span class="pc-usp-text">Grammar School Readiness</span>
              </div>

              
            </div>

          </div>

          <!-- ── photo ── -->
          <div class="pc-hero-media">
            <!-- TODO: replace with a real Sehyog student photo (keep 3 widths for mobile/tablet/desktop) -->
            <img
              class="pc-hero-img"
              src="https://images.pexels.com/photos/5905712/pexels-photo-5905712.jpeg"
              srcset="
                https://images.pexels.com/photos/5905712/pexels-photo-5905712.jpeg 540w,
                https://images.pexels.com/photos/5905712/pexels-photo-5905712.jpeg 760w,
                https://images.pexels.com/photos/5905712/pexels-photo-5905712.jpeg 900w"
              sizes="(max-width: 900px) 92vw, 44vw"
              alt="Student working through 11+ practice questions at home"
              width="900" height="700"
              loading="eager"
              fetchpriority="high"
              decoding="async" />
          </div>

        </div>

        <!-- ── plan snapshot strip (moved down — nice to know, not the headline act) ── -->
        <div class="pc-snap-strip">
          <p class="pc-snap-strip-title">Plan Snapshot</p>
          <div class="pc-snap-strip-row">
            <div class="pc-snap-item">
              <i class="ti ti-calendar pc-snap-icon"></i>
              <span><b>Starts:</b> 1 Sept 2026</span>
            </div>
            <div class="pc-snap-item">
              <i class="ti ti-device-laptop pc-snap-icon"></i>
              <span><b>Format:</b> Online, with optional F2F mocks</span>
            </div>
            <div class="pc-snap-item">
              <i class="ti ti-users pc-snap-icon"></i>
              <span><b>Suitable for:</b> Year 3 – Year 5 students</span>
            </div>
            <div class="pc-snap-item">
              <i class="ti ti-calendar-time pc-snap-icon"></i>
              <span><b>Weekly commitment:</b> 3 – 5 live sessions</span>
            </div>
            <div class="pc-snap-item">
              <i class="ti ti-clock pc-snap-icon"></i>
              <span><b>Session length</b> varies by plan</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>


  <!-- ═══════════════════ PLANS ═══════════════════ -->
  <section class="pc-compare">
    <div class="pc-container">

      <div class="pc-intro">
        <h2 class="pc-intro-title">Find the right plan for <span>your child</span></h2>
        <p class="pc-intro-sub">All plans run Sep 2026 – Jul 2027 &nbsp;·&nbsp; Flexible live class timings Mon–Sat &nbsp;·&nbsp; Online delivery</p>
      </div>

      <div class="pc-cards">

        <!-- ═══ YEAR 5 — FEATURED ═══ -->
        <div class="pc-card pc-card-featured">
          <span class="pc-card-stamp">Most chosen</span>

          <div class="pc-card-head">
            <p class="pc-card-eyebrow">Best for Year 5 Entry</p>
            <h3 class="pc-card-title">Year 5 Plan</h3>
            <p class="pc-card-sub">Full 11+ experience with F2F mocks</p>

            <div class="pc-price-seal pc-price-seal-gold">
              <span class="pc-ps-amount">£7.99</span>
              <span class="pc-ps-unit">/session</span>
            </div>
          </div>

          <div class="pc-card-body">
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-calendar"></i>Duration</span><span class="pc-leader"></span><span class="pc-lv pc-lv-gold">46 weeks</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-video"></i>Live classes</span><span class="pc-leader"></span><span class="pc-lv pc-lv-cyan">231 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-clock"></i>Per week</span><span class="pc-leader"></span><span class="pc-lv">5 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-test-pipe"></i>Practice tests</span><span class="pc-leader"></span><span class="pc-lv">140 online</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-pencil"></i>Assignments</span><span class="pc-leader"></span><span class="pc-lv">140 sets</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-users"></i>PTM sessions</span><span class="pc-leader"></span><span class="pc-lv">8 meetings</span></div>
            </div>

            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll">Maths</span><span class="pc-leader"></span><span class="pc-lv pc-lv-gold">62 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">English (RC + CW)</span><span class="pc-leader"></span><span class="pc-lv pc-lv-gold">62 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-gold">31 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Non-Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-gold">30 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Doubt clearing</span><span class="pc-leader"></span><span class="pc-lv">46 sessions</span></div>
            </div>

            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feature-list">
              <div class="pc-feature pc-feature-highlight"><i class="ti ti-school"></i>30 Face-to-Face mock exams</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Comprehensive RAR dashboard</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Pre-class notes &amp; materials</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Recorded session access</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Error log &amp; result history</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Weak area analysis &amp; counselling</div>
              <div class="pc-feature"><i class="ti ti-check"></i>LMS technology platform</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Customised subject options</div>
            </div>

            <a routerLink="/enrol" class="pc-cta pc-cta-primary">Sign up <span>&rarr;</span></a>
          </div>
        </div>

        <!-- ═══ YEAR 4 ═══ -->
        <div class="pc-card">
          <div class="pc-card-head">
            <p class="pc-card-eyebrow">Best for Year 4 Entry</p>
            <h3 class="pc-card-title">Year 4 Plan</h3>
            <p class="pc-card-sub">Build strong foundations early</p>

            <div class="pc-price-seal">
              <span class="pc-ps-amount">£7.99</span>
              <span class="pc-ps-unit">/session</span>
            </div>
          </div>

          <div class="pc-card-body">
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-calendar"></i>Duration</span><span class="pc-leader"></span><span class="pc-lv">46 weeks</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-video"></i>Live classes</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">184 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-clock"></i>Per week</span><span class="pc-leader"></span><span class="pc-lv">4 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-test-pipe"></i>Practice tests</span><span class="pc-leader"></span><span class="pc-lv">129 online</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-pencil"></i>Assignments</span><span class="pc-leader"></span><span class="pc-lv">129 sets</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-users"></i>PTM sessions</span><span class="pc-leader"></span><span class="pc-lv">8 meetings</span></div>
            </div>

            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll">Maths</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">46 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">English (RC + CW)</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">46 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">23 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Non-Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">23 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Doubt clearing</span><span class="pc-leader"></span><span class="pc-lv">46 sessions</span></div>
            </div>

            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feature-list">
              <div class="pc-feature pc-feature-missing"><i class="ti ti-x"></i>No F2F mock exams</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Comprehensive RAR dashboard</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Pre-class notes &amp; materials</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Recorded session access</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Error log &amp; result history</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Weak area analysis &amp; counselling</div>
              <div class="pc-feature"><i class="ti ti-check"></i>LMS technology platform</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Customised subject options</div>
            </div>

            <a routerLink="/enrol" class="pc-cta pc-cta-outline">Sign up <span>&rarr;</span></a>
          </div>
        </div>

        <!-- ═══ YEAR 3 ═══ -->
        <div class="pc-card">
          <div class="pc-card-head">
            <p class="pc-card-eyebrow">Best for Year 3 Entry</p>
            <h3 class="pc-card-title">Year 3 Plan</h3>
            <p class="pc-card-sub">Get ahead with an early start</p>

            <div class="pc-price-seal">
              <span class="pc-ps-amount">£7.99</span>
              <span class="pc-ps-unit">/session</span>
            </div>
          </div>

          <div class="pc-card-body">
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-calendar"></i>Duration</span><span class="pc-leader"></span><span class="pc-lv">46 weeks</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-video"></i>Live classes</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">184 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-clock"></i>Per week</span><span class="pc-leader"></span><span class="pc-lv">3 sessions</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-test-pipe"></i>Practice tests</span><span class="pc-leader"></span><span class="pc-lv">137 online</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-pencil"></i>Assignments</span><span class="pc-leader"></span><span class="pc-lv">137 sets</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-users"></i>PTM sessions</span><span class="pc-leader"></span><span class="pc-lv">8 meetings</span></div>
            </div>

            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll">Maths</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">46 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">English (RC + CW)</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">46 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">23 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Non-Verbal Reasoning</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">23 classes</span></div>
              <div class="pc-ledger-row"><span class="pc-ll">Doubt clearing</span><span class="pc-leader"></span><span class="pc-lv">46 sessions</span></div>
            </div>

            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feature-list">
              <div class="pc-feature pc-feature-missing"><i class="ti ti-x"></i>No F2F mock exams</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Comprehensive RAR dashboard</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Pre-class notes &amp; materials</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Recorded session access</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Error log &amp; result history</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Weak area analysis &amp; counselling</div>
              <div class="pc-feature"><i class="ti ti-check"></i>LMS technology platform</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Customised subject options</div>
            </div>

            <a routerLink="/enrol" class="pc-cta pc-cta-outline">Sign up <span>&rarr;</span></a>
          </div>
        </div>

        <!-- ═══ SINGLE SUBJECT ═══ -->
        <div class="pc-card">
          <div class="pc-card-head">
            <p class="pc-card-eyebrow">Flexible Option</p>
            <h3 class="pc-card-title">Single Subject</h3>
            <p class="pc-card-sub">Targeted prep in one area</p>

            <div class="pc-price-seal">
              <span class="pc-ps-amount">£49</span>
              <span class="pc-ps-unit">/month</span>
            </div>
          </div>

          <div class="pc-card-body">
            <div class="pc-ledger">
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-calendar"></i>Duration</span><span class="pc-leader"></span><span class="pc-lv">46 weeks</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-video"></i>Live classes</span><span class="pc-leader"></span><span class="pc-lv pc-lv-teal">Tailored</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-clock"></i>Per week</span><span class="pc-leader"></span><span class="pc-lv">Flexible</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-test-pipe"></i>Practice tests</span><span class="pc-leader"></span><span class="pc-lv">Per subject</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-pencil"></i>Assignments</span><span class="pc-leader"></span><span class="pc-lv">Per subject</span></div>
              <div class="pc-ledger-row"><span class="pc-ll"><i class="ti ti-users"></i>PTM sessions</span><span class="pc-leader"></span><span class="pc-lv">8 meetings</span></div>
            </div>

            <p class="pc-sec-label">Choose your subject</p>
            <div class="pc-feature-list">
              <div class="pc-feature"><i class="ti ti-check"></i>Maths</div>
              <div class="pc-feature"><i class="ti ti-check"></i>English — RC &amp; Creative Writing</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Verbal Reasoning</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Non-Verbal Reasoning</div>
            </div>

            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feature-list">
              <div class="pc-feature"><i class="ti ti-check"></i>Customised schedule &amp; pace</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Comprehensive RAR dashboard</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Recorded session access</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Error log &amp; result history</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Weak area analysis</div>
              <div class="pc-feature"><i class="ti ti-check"></i>LMS technology platform</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Flexible instalment payment</div>
              <div class="pc-feature"><i class="ti ti-check"></i>Cancellation policy included</div>
            </div>

            <a routerLink="/contact" class="pc-cta pc-cta-outline">Sign up <span>&rarr;</span></a>
          </div>
        </div>

      </div><!-- /pc-cards -->

      <!-- ═══ SHARED FEATURES ═══ -->
      <div class="pc-share">
        <p class="pc-share-title">What your child gets — on every plan</p>
        <div class="pc-share-list">
          <div class="pc-share-item" *ngFor="let item of sharedFeatures">
            <span class="pc-share-icon"><i class="ti" [class]="'ti ' + item.icon"></i></span>
            <div class="pc-share-copy">
              <p class="pc-share-item-title">{{ item.title }}</p>
              <p class="pc-share-item-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</div><!-- /pc-page -->